import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 27 27"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "13",
  cy: "14",
  r: "12",
  stroke: "#F7CDCD",
  "stroke-width": "2"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#B91F1F",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "3",
  d: "m16 11-6 6m0-6 6 6"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "#B91F1F",
  "stroke-linecap": "round",
  "stroke-width": "3",
  d: "M13 2c6.627 0 12 5.373 12 12 0 2.761-.933 5.305-2.5 7.332"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }